import React, {useEffect, useState} from 'react';
import {Link, useHistory, useParams} from "react-router-dom";
import {Select, Spin} from "antd";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";

import { Checkbox, Divider } from 'antd';
const CheckboxGroup = Checkbox.Group;
const CreateCompany = () => {
    let history = useHistory()
    let params = useParams()
    const [loader, setLoader] = useState(false)
    const [sendData, setSendData] = useState({
        phone: "+998751234567"
    })
    const [pic, setPic] = useState(null);
    const [data, setData] = useState([]);
    const [dataservice, setDataService] = useState([]);
    const [dataItem, setDataItem] = useState(false);
    const bigData = new FormData()
    const sendAll = () => {
        setLoader(true)
        if (pic) {
            bigData.append("logo", pic?.target?.files[0])
        } else {

        }
        if (sendData?.name) {
            bigData.append("name", sendData?.name)
        }
        if (sendData?.description) {
            bigData.append("description", sendData?.description)
        }
        if (sendData?.type) {
            bigData.append("type", sendData?.type)
        }
        if (sendData?.email) {
            bigData.append("email", sendData?.email)

        }
        if (sendData?.phone) {
            bigData.append("phone", sendData?.phone)
        }
        if (pic?.target?.files[0] || params?.id > 0) {
            if (params?.id > 0){
                axios.put(API_PATH + "company/update/" + params?.id, bigData, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                    .then(res => {
                        toast.success("Изменено успешно")
                        setLoader(false)
                        history.push("/global-admin/admin-companies")
                    })
                    .catch(err => {
                        setLoader(false)
                        toast.error(err?.response?.status + " " + JSON.stringify(err?.response?.data?.detail))
                    })
                axios.post(API_PATH + "service/company/" + params?.id + "/add-service/" , {"service_ids": dataservice}, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                    .then(res => {
                        setLoader(false)
                        history.push("/global-admin/admin-companies")
                    })
                    .catch(err => {
                        setLoader(false)
                        toast.error(err?.response?.status + " " + JSON.stringify(err?.response?.data?.detail))
                    })
            } else {
                axios.post(API_PATH + "company/create", bigData, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                    .then(res => {
                        toast.success("Добавлено успешно")
                        setLoader(false)
                        for (let i=0; i < sendData.services?.length; i++){
                            axios.post(API_PATH + "service/company/"+ res?.data?.id + "/add-service/", {service_id: sendData.services[i]}, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                                .then(res => {
                                    setLoader(false)
                                    if (sendData.services?.length - 1 === i ){
                                        history.push("/global-admin/admin-companies")
                                    }
                                })
                                .catch(err => {
                                    setLoader(false)
                                    toast.error(err?.response?.status + " " + JSON.stringify(err?.response?.data?.detail))
                                })
                        }

                    })
                    .catch(err => {
                        setLoader(false)
                        toast.error(err?.response?.status + " " + JSON.stringify(err?.response?.data?.detail))
                    })

            }


        } else {
            toast.error("Пожалуйста, выберите изображение")
            setLoader(false)
        }
    }

    const [photo123, setphoto123] = useState("/img/uploadimg.png");
    const uploadImg = (event) => {
        setphoto123(URL.createObjectURL(event?.target?.files[0]));
        setPic(event);
    };

    const plainOptions = ['Apple', 'Pear', 'Orange'];
    const onChange = (e) => {
        setDataService(e)
    }
    const getItem = () => {
        axios.get(API_PATH + "company/" + params?.id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                setSendData(res?.data)
                setphoto123(res?.data?.logo)
            })
        axios.get(API_PATH + "service/company/" + params?.id + "/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                setDataService(res?.data?.map(item => item?.id))
                setTimeout(() =>{
                    setDataItem(true)

                }, 300)
            })
    }
    const getAccessList = () => {
        axios.get(API_PATH  + "service/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                setData(res?.data)
            })
    }
    useEffect(() => {
        getAccessList()
        if (params?.id > 0){
            getItem()
        }
    }, []);

    return (
        <div className="profile-edit access-checks">
            <div className="progress-link">
                <Link to="/global-admin/admin-companies"> <img src="/icon/Icon1.svg" alt="."/></Link>
                <img src="/icon/arrowleft.svg" alt="."/>
                <Link to="/global-admin/admin-companies"> <span>Компании</span></Link>
                <img src="/icon/arrowleft.svg" alt="."/>
                <span><span>Добавить новую компанию</span></span>
            </div>
            <div className="profile-header pl-4">
                <h3 className="font-family-medium">Информация о новой компании</h3>
            </div>
            <div className="p-4">
                <div className="row">
                    <div className="col-md-4">

                        <div className="profile-header h-100  p-0">
                            <div className="profile-header-box-update h-100 m-0">

                                <h3 className="font-family-medium text-white mb-3">Компания</h3>
                                <div className="row">
                                    {/*<img src="/img/addphoto.png" alt="."/>*/}
                                    {/*<input type="file"*/}
                                    {/*       onChange={(e) => setPic(e.target.files[0])}*/}
                                    {/*/>*/}
                                    <div className="userPhoto w-100 p-2 m-0 ">
                                        <p className="font-family-bold text-start mb-2">Логотип </p>
                                        <label htmlFor="userPhoto" className="w-100" id="img1">
                                            {" "}
                                            <img src={photo123} className="w-100" alt=""/>
                                        </label>
                                        <input
                                            type="file"
                                            onChange={(e) => uploadImg(e)}
                                            id="userPhoto"
                                        />

                                    </div>
                                    <div className="inputs-box mt-3">
                                        <label className="font-family-medium">Название компании </label>
                                        <input type="text"
                                               value={sendData?.name}
                                               onChange={(e) => setSendData({
                                            ...sendData,
                                            name: e.target.value
                                        })}/>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-md-4">
                        <div className="profile-header  h-100 p-0">
                            <div className="profile-header-box-update h-100 m-0">
                                <h3 className="font-family-medium text-white mb-3">Пользователь</h3>

                                <div className="inputs-box">
                                    <label className="font-family-medium">Телефон</label>
                                    <input type="text"
                                           value={sendData?.phone}
                                           onChange={(e) => setSendData({
                                        ...sendData,
                                        phone: e.target.value
                                    })}/>
                                </div>
                                <div className="inputs-box">
                                    <label className="font-family-medium">Email</label>
                                    <input type="text"
                                           value={sendData?.email}
                                           onChange={(e) => setSendData({
                                        ...sendData,
                                        email: e.target.value
                                    })}/>
                                </div>


                                <div className="inputs-box">
                                    <label className="font-family-medium">Тип</label>
                                    <Select
                                        className="w-100"
                                        value={sendData?.type}
                                        onChange={(e) => setSendData({...sendData, type: e})}
                                    >
                                        <option value="null">Bank</option>
                                        <option value="1">Bank</option>
                                    </Select>
                                </div>
                                <div className="inputs-box">
                                    <label className="font-family-medium">Описание</label>
                                    <input type="textarea"
                                           value={sendData?.description}
                                           onChange={(e) => setSendData({
                                        ...sendData,
                                        description: e.target.value
                                    })}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4  ">
                        <div className="profile-header  h-100 p-0">
                            <div className="profile-header-box-update h-100 m-0">
                                <h3 className="font-family-medium text-white  mb-3">Доступность</h3>
                                {
                                    dataItem ?
                                        <>
                                            {params?.id > 0 ?
                                                <Checkbox.Group defaultValue={dataservice} style={{width: '100%'}}
                                                                onChange={onChange}>
                                                    {
                                                        data?.map((item, index) => (
                                                            <div className="d-block w-100 mb-2">
                                                                <Checkbox className="checkbox-my" value={item?.id}>
                                                                    <h6 className="text-white">{item?.title}</h6>
                                                                </Checkbox>
                                                            </div>
                                                        ))
                                                    }
                                                </Checkbox.Group>


                                                :
                                                <Checkbox.Group style={{width: '100%'}} onChange={onChange}>
                                                    {data?.map((item, index) => (
                                                        <div className="d-block w-100 mb-2">
                                                            <Checkbox className="checkbox-my" value={item?.id}>
                                                                <h6 className="text-white">{item?.title}</h6></Checkbox>
                                                        </div>
                                                    ))}
                                                </Checkbox.Group>}
                                        </>
                                :
                                    ""
                                }

                                <div className="con-btn mt-4 w-auto">
                                    <button className="font-family-medium ant-btn-primary" onClick={  sendAll }><span>

                                        {
                                            params?.id > 0 ?
                                                "Редактировать"
                                                :
                                                "Создать"
                                        }
                                    </span></button>
                                    <button className="font-family-medium ml-8" onClick={() => history.goBack()}>Отменить</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {
                loader
                    ?

                    <div className="my-loader">
                        <Spin size="large"/>
                    </div>
                    :
                    ""
            }

        </div>
    );
};

export default CreateCompany;